import { EditQueuePriorityModal } from "./EditQueuePriorityModal";

export default EditQueuePriorityModal;
